<template>
  <div>

    <el-breadcrumb id="nav" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/menu/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营数据</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>患者</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <div id="top">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-select
              v-model="queryForm.registerHospitalId"
              placeholder="请选择注册医院"
              clearable
              @change="onHospitalChange"
            >
              <el-option
                v-for="h in hospitalList"
                :key="h.id"
                :label="h.name"
                :value="h.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-input
              placeholder="请输入手机号"
              v-model="inputPhone"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="onSearch"
              ></el-button>
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button
              type="info"
              plain
              @click="clearInput"
            >清除输入
            </el-button>
          </el-col>
        </el-row>
      </div>
      <TablePage :total="total" :page-size="pageSize" :page-sizes="[5,10,15,20]"
                 @sizeChange="sizeChange"
                 @pageChange="pageChange">
        <el-table
          v-loading="loading"
          :height="tableHeight"
          :data="doctors"
          style="width: 100%"
          stripe
          border
        >
          <el-table-column
            prop="createDate"
            label="日期"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="realname"
            label="姓名"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="hospital"
            label="医院"
            width="230"
          >
          </el-table-column>
          <el-table-column
            prop="inviterName"
            label="医院渠道"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="registerHospital"
            label="注册选择医院"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="registerDoctorName"
            label="注册选择医生(邀请人)"
          >
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="400"
          >
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row)"
                type="text"
                size="small"
              >查看
              </el-button>
              <el-button
                type="text"
                size="small"
              >编辑
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="showTrainingPlan(scope.row)"
              >查看训练方案
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="showSmsLog(scope.row)"
              >查看短信记录
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="changeHopsital(scope.row)"
              >切换医院
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </TablePage>
      <!--      <el-pagination-->
      <!--        @size-change="handleSizeChange"-->
      <!--        @current-change="handleCurrentChange"-->
      <!--        :page-size="pageSize"-->
      <!--        layout="total, prev, pager, next"-->
      <!--        :total="total"-->
      <!--      >-->
      <!--      </el-pagination>-->
    </el-card>
    <el-dialog title="切换医院" :visible.sync="dialogChangeHospitalVisible">
      <!--      <div v-if="loadingGetChangeHospitalList"></div>-->
      <!--      <div v-else></div>-->
      <el-table
        v-loading="loadingGetChangeHospitalList"
        :data="changeHospitalList"
        border
        stripe
        ref="changeHospitalTableData"
        style="width: 100%">
        <el-table-column
          width="100"
          align="center"
          label="当前医院">
          <template slot-scope="scope">
            <el-radio v-model="changeHospitalSeleced" :label="scope.row.hospitalId">{{ ' ' }}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="医院"
        >
        </el-table-column>
      </el-table>
      <el-row style="margin-top: 32px" type="flex" justify="end">
        <el-button type="info" @click="dialogChangeHospitalVisible = false">取消</el-button>
        <el-button type="primary" @click="changeHospitalSelection">确定</el-button>
      </el-row>
    </el-dialog>

    <!-- 训练方案弹窗 -->
    <el-dialog title="训练方案" :visible.sync="planDialogVisible" width="900px">
      <el-table
        v-loading="planLoading"
        :data="planList"
        stripe
        style="width: 100%"
      >
        <el-table-column
          prop="planName"
          label="方案名称"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="startDate"
          label="开始日期"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="days"
          label="训练天数"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="planType"
          label="方案类型"
          width="120"
        ></el-table-column>
      </el-table>
      <div v-if="planList.length === 0 && !planLoading" style="text-align: center; color: #999; padding: 20px;">
        暂无数据
      </div>
    </el-dialog>

    <!-- 短信记录弹窗 -->
    <el-dialog title="短信发送记录" :visible.sync="smsDialogVisible" width="900px">
      <el-table
        v-loading="smsLoading"
        :data="smsLogList"
        stripe
        style="width: 100%"
      >
        <el-table-column
          prop="smsType"
          label="短信类型"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="messageContent"
          label="内容"
          min-width="200"
        ></el-table-column>
        <el-table-column
          prop="sendStatus"
          label="状态"
          width="100"
        >
          <template slot-scope="scope">
            <span :style="{ color: scope.row.sendStatus === 1 ? 'green' : 'red' }">
              {{ scope.row.sendStatus === 1 ? '成功' : '失败' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sendTime"
          label="发送时间"
          width="180"
        ></el-table-column>
      </el-table>
      <div v-if="smsLogList.length === 0 && !smsLoading" style="text-align: center; color: #999; padding: 20px;">
        暂无数据
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TablePage from '../../../common-components/TablePage'

export default {
  components: { TablePage },
  data () {
    return {
      loading: true,
      inputPhone: '',
      page: 1,
      pageSize: 15,
      total: 0,
      doctors: [],
      hospitals: [],
      hospitalList: [],
      queryForm: {
        registerHospitalId: null
      },
      dialogChangeHospitalVisible: false,
      loadingGetChangeHospitalList: true,
      changeHospitalList: [],
      operatorPatient: null,
      changeHospitalSeleced: '',
      tableHeight: 400,
      // 训练方案弹窗
      planDialogVisible: false,
      planList: [],
      planLoading: false,
      // 短信记录弹窗
      smsDialogVisible: false,
      smsLogList: [],
      smsLoading: false
    }
  },
  created () {
    // this.getHosiptals()
  },
  mounted () {
    this.$nextTick(() => {
      // 窗口高度 - 上边其他布局高度 - 最上面的导航栏高度和其他边距高度(225) = 表格高度（也就是剩下的高度）
      const number = document.getElementById('top').offsetHeight + document.getElementById('nav').offsetHeight + 220
      console.log('其他高度', number)
      this.tableHeight = (window.innerHeight - number)
    })
    this.loadHospitals()
    this.getPatients()
  },
  methods: {
    async onSearch () {
      this.loading = true
      console.log('搜索', this.inputPhone)
      this.pageSize = 100
      this.page = 1
      const { data: resp } = await this.$http.get('cms/patient/phone', {
        params: {
          phone: this.inputPhone
        }
      })

      // this.doctors = [
      //   { name: '陈其康', hospital: '动优健康管理中心', date: '2020年8月23日', phone: '13610386482' }
      // ]
      console.log(resp)
      if (resp.code !== 200) return this.$message.error(resp.message)

      resp.data.content.forEach(function (d) {
        d.createDate = new Date(d.createDate).toLocaleString()
      })
      this.doctors = resp.data.content
      this.total = resp.data.totalElements
      this.pageSize = resp.data.size
      this.loading = false
    },
    async changeHospitalSelection () {
      if (this.changeHospitalSeleced !== this.operatorPatient.hospitalCode) {
        console.log('修改了医院')
        const rsp = await this.$http.post('cms/patient/changeHospital', {
          userId: this.operatorPatient.userId,
          hospitalId: this.changeHospitalSeleced
        })
        if (rsp.data.code === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.dialogChangeHospitalVisible = false
        } else {
          this.$message({
            message: '修改失败:' + rsp.data.message,
            type: 'error'
          })
        }
      } else {
        console.log('没修改医院')
      }
    },
    async changeHopsital (patient) {
      this.operatorPatient = patient
      this.changeHospitalList = []
      this.changeHospitalSeleced = patient.hospitalCode
      console.log('切换医院', patient)
      this.dialogChangeHospitalVisible = true
      const hospitals = await this.getHosiptals()
      for (const key in hospitals) {
        console.log(hospitals[key])
        this.changeHospitalList.push({
          name: hospitals[key].name,
          hospitalId: hospitals[key].hospitalId
        })
      }
      this.loadingGetChangeHospitalList = false
    },
    async getHosiptals () {
      this.loading = true
      const { data: resp } = await this.$http.get('regist/hospitals')
      console.log(resp)
      if (resp.code !== 200) return this.$message.error(resp.message)
      this.loading = false
      return resp.data
    },
    // async getHosiptals () {
    //   const { data: resp } = await this.$http.get('cms/doctor/hospitals')
    //   console.log(resp)
    //   if (resp.code !== 200) return this.$message.error(resp.message)
    //
    //   this.hospitals = resp.data
    // },
    async getPatients () {
      this.loading = true
      // this.doctors = [
      //   { name: '陈其康', hospital: '动优健康管理中心', date: '2020年8月23日', phone: '13610386482' }
      // ]
      const { data: resp } = await this.$http.get('cms/patient/list', {
        params: {
          page: this.page,
          pageSize: this.pageSize,
          registerHospitalId: this.queryForm.registerHospitalId
        }
      })
      console.log(resp)
      if (resp.code !== 200) return this.$message.error(resp.message)

      resp.data.content.forEach(function (d) {
        d.createDate = new Date(d.createDate).toLocaleString()
      })
      this.doctors = resp.data.content
      this.total = resp.data.totalElements
      this.pageSize = resp.data.size
      this.loading = false
    },
    sizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.getPatients()
    },
    pageChange (val) {
      console.log(`当前页: ${val}`)
      this.page = val
      this.getPatients()
    },
    // 加载医院列表
    async loadHospitals () {
      try {
        const { data: resp } = await this.$http.get('cms/hospital/list')
        if (resp.code === 200) {
          this.hospitalList = resp.data || []
        }
      } catch (e) {
        console.error('加载医院列表失败', e)
      }
    },
    // 医院下拉变化
    onHospitalChange () {
      this.page = 1
      this.inputPhone = ''
      this.getPatients()
    },
    // 清除输入
    clearInput () {
      this.inputPhone = ''
      this.queryForm.registerHospitalId = null
      this.page = 1
      this.getPatients()
    },
    // 查看训练方案
    async showTrainingPlan (patient) {
      this.planDialogVisible = true
      this.planLoading = true
      this.planList = []
      try {
        const { data: resp } = await this.$http.get('cms/patient/plans', {
          params: { patientId: patient.userId }
        })
        if (resp.code === 200) {
          this.planList = resp.data || []
        } else {
          this.$message.warning(resp.message || '加载训练方案失败')
        }
      } catch (e) {
        console.error('加载训练方案失败', e)
        this.$message.error('加载训练方案失败')
      } finally {
        this.planLoading = false
      }
    },
    // 查看短信记录
    async showSmsLog (patient) {
      this.smsDialogVisible = true
      this.smsLoading = true
      this.smsLogList = []
      try {
        const { data: resp } = await this.$http.get('cms/sms/log/list', {
          params: { patientPhone: patient.phone }
        })
        if (resp.code === 200) {
          this.smsLogList = resp.data || []
        } else {
          this.$message.warning(resp.message || '加载短信记录失败')
        }
      } catch (e) {
        console.error('加载短信记录失败', e)
        this.$message.error('加载短信记录失败')
      } finally {
        this.smsLoading = false
      }
    },
    handleClick (row) {
      // 查看患者详情
      this.$message.info('患者详情：' + row.realname)
    }
  }

}
</script>

<style lang="less" scoped>
.el-table {
  margin-top: 15px;
  font-size: 10px;
}
</style>
